import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  size?: 'lg' | 'xl';
  className?: string;
  showIcon?: boolean;
}
export function CTAButton({
  text,
  size = 'lg',
  className = '',
  showIcon = true
}: CTAButtonProps) {
  const baseClasses = 'relative inline-flex items-center justify-center font-bold text-white transition-all duration-300 rounded-full group overflow-hidden';
  const sizeClasses = size === 'xl' ? 'px-8 py-4 text-xl md:text-2xl' : 'px-6 py-3 text-lg';
  const colorClasses = 'bg-gradient-to-r from-violet-600 via-purple-600 to-indigo-600 hover:from-violet-500 hover:via-purple-500 hover:to-indigo-500 shadow-[0_0_20px_rgba(124,58,237,0.5)] hover:shadow-[0_0_35px_rgba(124,58,237,0.7)]';
  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Reiki MegaPack',
        content_category: 'Curso Online',
        value: 19990,
        currency: 'CLP'
      });
    }
  };
  return <motion.a href="https://pay.hotmart.com/O103704589E" target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`${baseClasses} ${sizeClasses} ${colorClasses} ${className} animate-pulse-glow-strong`} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.95
  }} data-id="element-71">
      {/* Shimmer effect overlay */}
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-10" data-id="element-72" />

      <span className="relative z-20 flex items-center gap-2" data-id="element-73">
        {text}
        {showIcon && <ArrowRight className="w-5 h-5 md:w-6 md:h-6 group-hover:translate-x-1 transition-transform" data-id="element-74" />}
      </span>
    </motion.a>;
}